import React from 'react'
import Button from '../../../shared/components/atoms/button/button';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './section-caretakers-introduction.scss'

const SectionCaretakersIntroduction = ({ contentInfo }) => {

    const firstContent = contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido1")[0]
    const secondContent = contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido2")[0]

    const paragraph = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-caretakers-introduction__item-paragraph">{next}</p>
        }
    };

    const { homeLink } = useHomeLinkMode();

    return (
        <section className="f-m-caretakers-introduction">
            <div className="f-m-caretakers-introduction__content">
                <div className="f-m-caretakers-introduction__item __first">
                    <div className="f-m-caretakers-introduction__item-text">
                        <h1 className="f-m-caretakers-introduction__item-title">{firstContent.tituloGeneral}</h1>
                        {firstContent.descripcion.raw && documentToReactComponents(JSON.parse(firstContent.descripcion.raw), paragraph)}
                        <Button
                            id="f-a-buttton__caretakers-introduction"
                            className={"f-a-button__primary-blue f-a-button__big"}
                            copy={firstContent.textoBoton}
                            onclick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + "como-participo/" }}
                        />
                    </div>
                    <div className="f-m-caretakers-introduction__item-image-container">
                        <img
                            src={firstContent.imagen[0].file.url}
                            alt={firstContent.imagen[0].descripcion}
                        />
                    </div>
                </div>
                <div className="f-m-caretakers-introduction__item __second">
                    <div className="f-m-caretakers-introduction__item-image-container">
                        <img
                            src={secondContent.imagen[0].file.url}
                            alt={secondContent.imagen[0].descripcion}
                        />
                    </div>
                    <div className="f-m-caretakers-introduction__item-text">
                        <h2 className="f-m-caretakers-introduction__item-title">{secondContent.tituloGeneral}</h2>
                        {secondContent.descripcion.raw && documentToReactComponents(JSON.parse(secondContent.descripcion.raw), paragraph)}
                    </div>

                </div>
            </div>
        </section>
    )
}

export default SectionCaretakersIntroduction
